import React, { Suspense, lazy, useEffect } from 'react';
import styled from '@emotion/styled';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { ThemeProvider } from '@mui/material/styles';
import useAuthStore from './store/authStore';
import { useThemeStore } from './store/themeStore';
import { getTheme } from './theme';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import Header from './components/Layout/Header';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import GlobalStyles from './styles/GlobalStyles';
import AdminDashboardPage from './pages/Admin/AdminDashboardPage';

const ChatPage = lazy(() => import('./components/Chat/ChatPage'));

// Komponenta za preusmeritev na korenu (/)
const RootRedirect = () => {
  const { isAuthenticated } = useAuthStore();
  return isAuthenticated ? <Navigate to="/chat" replace /> : <Navigate to="/login" replace />;
};

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100dvh;
  width: 100%;
  overflow-x: hidden;
  background: var(--app-bg-gradient);
`;

const MainContent = styled.main`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 2rem;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

function App() {
  const { mode } = useThemeStore();

  useEffect(() => {
    document.body.setAttribute('data-theme', mode);
  }, [mode]);

  const theme = getTheme(mode);

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <GlobalStyles /> {/* Add GlobalStyles component here */}
        {/* UPORABITE AppContainer TUKAJ */}
        <AppContainer>
          <Header />
          {/* UPORABITE MainContent TUKAJ */}
          <MainContent>
            <Suspense fallback={<div className="fallback">Loading...</div>}>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route
                  path="/chat"
                  element={
                    <ProtectedRoute>
                      <ChatPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute>
                      <AdminDashboardPage />
                    </ProtectedRoute>
                  }
                />
                <Route path="/" element={<RootRedirect />} />
              </Routes>
            </Suspense>
          </MainContent>
        </AppContainer>
        <Toaster
          toastOptions={{
            style: {
              background: 'var(--bg-paper)',
              color: 'var(--text-primary)',
              border: '1px solid var(--border-color)',
            },
          }}
        />
      </Router>
    </ThemeProvider>
  );
}

export default App;
